<template>
  <div>
    <s-crud
      title="Manejo de buses"
      :config="configBus"
      add
      edit
      remove
      @save="save($event)"
      :filter="filter"
      @EditEvent="editEvent($event)"
      @rowSelected="onBusSelected"
    >
      <template v-slot="props">
        <v-container>
          <v-row>
            <v-col class="s-col-form">
              <s-text
                label="Cod Empresa"
                v-model="props.item.BscCompany"
              ></s-text>
            </v-col>
            <!-- <v-col class="s-col-form">
              <s-toolbar-person
                label="DNI Conductor"
                return-object
                @returnPerson="hadReturnPerson($event, props.item)"
                v-model="props.item.BscDniDriver"
              />
            </v-col>
            <v-col class="s-col-form">
              <s-text
                label="Nombre Conductor"
                v-model="props.item.BscNameDriver"
              ></s-text>
            </v-col>
            <v-col class="s-col-form">
              <s-text label="Brevete" v-model="props.item.BscLicense"></s-text>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col class="s-col-form">
              <s-text
                label="Placa"
                v-model="props.item.BscLicencePlate"
              ></s-text>
            </v-col>
            <v-col class="s-col-form">
              <s-text label="Capacidad" number v-model="props.item.BscCapacity"></s-text>
            </v-col>
            <v-col class="s-col-form">
              <s-text label="Soat" v-model="props.item.BscSoat"></s-text>
            </v-col>
            <v-col class="s-col-form">
              <s-text
                label="Tarjeta de propiedad"
                v-model="props.item.BscPropertyCard"
              ></s-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="s-col-form">
              <s-text
                label="Revisión Técnica"
                v-model="props.item.BscTechnicalReview"
              ></s-text>
            </v-col>
            <v-col class="s-col-form">
              <s-select-definition
                label="Destino"
                :def="1379"
                add
                v-model="props.item.TypeRoute"
              ></s-select-definition>
            </v-col>
            <v-col class="s-col-form">
              <s-select-definition
                label="Puerta"
                :def="1116"
                :dgr="50"
                v-model="props.item.TypeDoor"
              ></s-select-definition>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <s-text
                label="Costo Por Viaje"
                decimal
                v-model="props.item.BscCost"
              ></s-text>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <!-- Slot para columna acciones de rutas (FIX: usar { item } en lugar de { row }) -->
      <template v-slot:item.actionsRoute="{ item }">
        <v-btn icon x-small color="primary" @click.stop="openRouteManager(item)">
          <v-icon small>mdi mdi-map-marker-distance</v-icon>
        </v-btn>
      </template>
    </s-crud>

    <!-- <bus-turn-assign-crud class="mt-4" v-if="selectedBusID" :bus-id="selectedBusID" /> -->

    <!-- Listado de Paraderos (reemplaza el segundo s-crud) -->
    <v-card class="mt-4" outlined>
      <v-toolbar flat dense color="grey lighten-4">
        <v-toolbar-title style="font-size: 14px">Paraderos del Bus</v-toolbar-title>
        <v-spacer />
        <v-switch
          v-model="showInactiveStops"
          inset
          hide-details
          class="mr-4"
          :disabled="!selectedBusID"
          label="Mostrar inactivos"
        />
        <v-text-field
          v-model="busStopsSearch"
          append-icon="mdi-magnify"
          label="Buscar"
          hide-details
          dense
          outlined
          style="max-width: 220px"
          :disabled="!selectedBusID"
        />
        <v-btn
          small
          color="primary"
          class="ml-2"
          :disabled="!selectedBusID"
          @click="openNewBusStop"
        >
          <v-icon left small>mdi-plus</v-icon> Nuevo
        </v-btn>
      </v-toolbar>

      <v-alert v-if="!selectedBusID" type="info" text class="ma-4" dense
        >Selecciona un bus para listar sus paraderos.</v-alert
      >

      <v-data-table
        v-else
        :headers="busStopsHeaders"
        :items="busStops"
        :page.sync="busStopsPage"
        :items-per-page.sync="busStopsItemsPerPage"
        :server-items-length="busStopsTotal"
        :loading="busStopsLoading"
        loading-text="Cargando..."
        class="elevation-1"
        dense
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
          showFirstLastPage: true,
        }"
      >
        <template v-slot:item.StpLatitude="{ item }">
          <span>{{ Number(item.StpLatitude).toFixed(6) }}</span>
        </template>
        <template v-slot:item.StpLongitude="{ item }">
          <span>{{ Number(item.StpLongitude).toFixed(6) }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon x-small color="primary" @click="openEditBusStop(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon x-small color="red" @click="deleteBusStop(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.StpName="{ item }">
          <div class="d-flex align-center">
            <span>{{ item.StpName }}</span>
            <v-chip
              v-if="item.SecStatus === 0"
              x-small
              color="red lighten-2"
              text-color="white"
              class="ml-2"
              >INACTIVO</v-chip
            >
          </div>
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pa-4">
            <v-chip color="grey lighten-3">Sin paraderos</v-chip>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <!-- Listado de Conductores -->
    <v-card class="mt-4" outlined v-if="selectedBusID">
      <v-toolbar flat dense color="grey lighten-4">
        <v-toolbar-title style="font-size: 14px">Conductores del Bus</v-toolbar-title>
        <v-spacer />
        <v-btn small color="primary" @click="openDriverModal">
          <v-icon left small>mdi-plus</v-icon> Agregar Conductor
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="busDriversHeaders"
        :items="busDrivers"
        :loading="busDriversLoading"
        dense
        hide-default-footer
      >
        <template v-slot:item.actions="{ item }">
          <v-btn icon x-small color="primary" @click="openEditDriver(item)" title="Editar">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon x-small color="info" @click="openMoveDriverModal(item)" title="Mover a otro bus">
            <v-icon small>mdi-bus-alert</v-icon>
          </v-btn>
          <v-btn icon x-small color="red" @click="deleteBusDriver(item)" title="Eliminar">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pa-4">
            <v-chip color="grey lighten-3">Sin conductores asignados</v-chip>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal Agregar / Editar Conductor -->
    <v-dialog v-model="showDriverModal" max-width="500px" persistent>
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>{{ newDriver.BdrID ? 'Editar Conductor' : 'Agregar Conductor' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDriverModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <s-toolbar-person
            :disabled="newDriver.PrsID != null"
            label="Buscar Conductor"
            return-object
            @returnPerson="onDriverSelected"
            v-model="newDriver.PrsDocumentNumber"
          />
          <v-text-field
            v-if="newDriver.PrsFullName"
            label="Nombre"
            v-model="newDriver.PrsFullName"
            readonly
            dense
            outlined
            class="mt-3"
          ></v-text-field>
          <v-text-field
            label="Número de Licencia"
            v-model="newDriver.BdrLicenseNumber"
            outlined
            dense
            class="mt-3"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeDriverModal">Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="saveBusDriver"
            :disabled="!newDriver.PrsID || savingDriver ||
              !newDriver.BdrLicenseNumber ||
              newDriver.BdrLicenseNumber.trim() === ''"
            :loading="savingDriver"
          >
            {{ newDriver.BdrID ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Mover Conductor -->
    <v-dialog v-model="showMoveDriverModal" max-width="500px" persistent>
      <v-card>
        <v-toolbar color="info" dark dense>
          <v-toolbar-title>Mover Conductor a otro Bus</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeMoveDriverModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <div class="mb-4 text-body-1">
            Conductor:
            <strong>{{ driverToMove ? driverToMove.PrsFullName : "" }}</strong>
          </div>
          <v-autocomplete
            v-model="targetBusID"
            :items="busesList"
            item-text="BscLicencePlate"
            item-value="BscID"
            label="Seleccione Bus de Destino"
            placeholder="Buscar por placa..."
            outlined
            dense
          >
            <template v-slot:item="{ item }">
              {{ item.BscLicencePlate }} - {{ item.BscCompany || "Sin empresa" }}
            </template>
            <template v-slot:selection="{ item }">
              {{ item.BscLicencePlate }} - {{ item.BscCompany || "Sin empresa" }}
            </template>
          </v-autocomplete>
          <v-alert type="warning" dense text class="mt-2" v-if="targetBusID">
            El conductor será removido del bus actual y asignado al seleccionado.
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeMoveDriverModal">Cancelar</v-btn>
          <v-btn
            color="info"
            @click="saveMoveDriver"
            :disabled="!targetBusID || movingDriver"
            :loading="movingDriver"
          >
            Mover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Registrar / Editar Paradero -->
    <v-dialog
      v-model="showBusStopModal"
      max-width="600px"
      persistent
      @input="onDialogToggle"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{
            busStop.StpID ? "Editar Paradero" : "Registrar Paradero"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeBusStopModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-form ref="busStopForm" @submit.prevent="saveBusStopModal">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="busStop.StpName"
                  label="Nombre del Paradero"
                  required
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="busStop.StpObservation"
                  label="Observación"
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <!-- Instrucciones para el mapa -->
            <v-row dense>
              <v-col cols="12">
                <v-alert dense text type="info" class="mb-3">
                  <v-icon left small>mdi-information</v-icon>
                  Haz clic en el mapa para seleccionar la ubicación del paradero
                </v-alert>
              </v-col>
            </v-row>

            <!-- Contenedor del mapa -->
            <v-row dense>
              <v-col cols="12">
                <div class="map-container" :key="mapKey">
                  <l-map
                    ref="map"
                    :zoom="mapZoom"
                    :center="mapCenter"
                    @click="handleMapClick"
                    @ready="onMapReady"
                    :options="mapOptions"
                  >
                    <l-tile-layer :url="tileUrl" />
                    <l-marker
                      v-if="busStop.StpLatitude && busStop.StpLongitude"
                      :lat-lng="[busStop.StpLatitude, busStop.StpLongitude]"
                      :icon="customIcon"
                    >
                      <l-tooltip :options="{ permanent: true, direction: 'top' }">
                        {{ busStop.StpName || "Nuevo Paradero" }}
                      </l-tooltip>
                    </l-marker>
                  </l-map>
                </div>
              </v-col>
            </v-row>

            <!-- Coordenadas -->
            <v-row dense class="mt-2">
              <v-col cols="6">
                <v-text-field
                  v-model="busStop.StpLatitude"
                  label="Latitud"
                  readonly
                  outlined
                  dense
                  prepend-inner-icon="mdi-map-marker"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="busStop.StpLongitude"
                  label="Longitud"
                  readonly
                  outlined
                  dense
                  prepend-inner-icon="mdi-map-marker"
                />
              </v-col>
            </v-row>

            <!-- Botón para obtener ubicación actual -->
            <v-row dense>
              <v-col cols="12" class="text-center">
                <v-btn
                  color="accent"
                  outlined
                  small
                  @click="getCurrentLocation"
                  :loading="gettingLocation"
                >
                  <v-icon left small>mdi-crosshairs-gps</v-icon>
                  Usar mi ubicación
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeBusStopModal" class="mr-2"> Cancelar </v-btn>
          <v-btn
            color="primary"
            @click="saveBusStopModal"
            :disabled="
              !busStop.StpName ||
              savingBusStop
            "
            :loading="savingBusStop"
          >
            <v-icon left small>mdi-content-save</v-icon>
            {{ busStop.StpID ? "Actualizar" : "Guardar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Gestión de Rutas -->
    <v-dialog v-model="showRouteModal" max-width="1000px" persistent>
      <v-card>
        <v-toolbar dense color="indigo" dark>
          <v-toolbar-title>Rutas del Bus: {{ currentBusDisplay }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="closeRouteModal"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-card outlined>
                <v-toolbar flat dense color="grey lighten-4">
                  <span style="font-size: 13px">Rutas</span>
                  <v-spacer />
                  <v-btn icon small color="primary" @click="startNewRoute">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-data-table
                  :headers="routeHeaders"
                  :items="routes"
                  :item-key="'RotID'"
                  dense
                  :loading="routesLoading"
                  height="300"
                  @click:row="selectRoute"
                  :class="{ 'elevation-1': true }"
                  :hide-default-footer="true"
                >
                  <template v-slot:item.RotStartDate="{ item }">
                    <span>{{ $fun.formatDateView(item.RotStartDate) }}</span>
                  </template>
                  <template v-slot:item.RotEndDate="{ item }">
                    <span>{{ $fun.formatDateView(item.RotEndDate) }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon x-small color="primary" @click.stop="editRoute(item)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon x-small color="red" @click.stop="deleteRoute(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <v-chip small color="grey lighten-3">Sin rutas</v-chip>
                  </template>
                </v-data-table>
                <v-form ref="routeForm" class="pa-3" v-if="routeEdit">
                  <s-text label="Alias" v-model="routeForm.RotAlias" dense />
                  <!-- <v-text-field
                    v-model="routeForm.RotAlias"
                    label="Alias"
                    dense
                    outlined
                    required
                  /> -->
                  <!-- <v-menu
                    ref="m1"
                    v-model="menuStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        outlined
                        v-model="routeForm.RotStartDate"
                        label="Inicio"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                  </v-menu> -->
                  <s-date label="Fecha Fin" v-model="routeForm.RotStartDate"></s-date>
                  <s-date label="Fecha Fin" v-model="routeForm.RotEndDate"></s-date>
                  <!-- <v-menu
                    ref="m2"
                    v-model="menuEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        outlined
                        v-model="routeForm.RotEndDate"
                        label="Fin"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="routeForm.RotEndDate"
                      @input="menuEnd = false"
                    />
                  </v-menu> -->
                  <v-btn
                    block
                    small
                    color="primary"
                    class="mt-2"
                    @click="saveRoute"
                    :loading="savingRoute"
                    :disabled="!routeForm.RotAlias || savingNewRoute"
                  >
                    <v-icon left small>mdi-content-save</v-icon
                    >{{ routeForm.RotID ? "Actualizar" : "Guardar solo Ruta" }}
                  </v-btn>
                  <!-- NUEVO: guardar ruta + paraderos iniciales (solo ruta nueva) -->
                  <v-btn
                    block
                    small
                    color="green darken-1"
                    class="mt-1"
                    v-if="!routeForm.RotID && newRouteStops.length > 0"
                    :loading="savingNewRoute"
                    @click="saveNewRouteFull"
                  >
                    <v-icon left small>mdi-content-save-all</v-icon>Guardar Ruta +
                    Paraderos
                  </v-btn>
                  <v-btn
                    block
                    small
                    text
                    class="mt-1"
                    @click="cancelRouteEdit"
                    :disabled="savingNewRoute"
                    >Cancelar</v-btn
                  >

                  <!-- NUEVO: Lista drag & drop de paraderos iniciales -->
                  <v-alert dense type="info" v-if="!routeForm.RotID" class="mt-4 mb-2">
                    <v-icon left>mdi-information-outline</v-icon>
                    <strong>Instrucciones:</strong> Organiza los paraderos arrastrándolos
                    en el orden del recorrido.
                    <ul class="mt-1 mb-0">
                      <li>El primer paradero será el inicio del recorrido</li>
                      <li>El último paradero será el final del recorrido</li>
                      <li>Usa el ícono <v-icon small>mdi-drag</v-icon> para arrastrar</li>
                      <li>
                        Usa el botón <v-icon small color="red">mdi-close</v-icon> para
                        quitar un paradero
                      </li>
                    </ul>
                  </v-alert>
                  <div v-if="!routeForm.RotID">
                    <p class="caption font-weight-medium mb-2">
                      Paraderos en orden de recorrido:
                      <span class="primary--text">{{ newRouteStops.length }}</span>
                    </p>
                    <v-sheet
                      outlined
                      rounded
                      class="pa-2"
                      :class="{ 'grey lighten-4': newRouteStops.length === 0 }"
                    >
                      <draggable
                        v-model="newRouteStops"
                        handle=".drag-handle"
                        tag="div"
                        @end="onNewRouteDragEnd"
                        :animation="200"
                        ghost-class="ghost-stop"
                        drag-class="drag-stop"
                        group="paraderos"
                      >
                        <v-sheet
                          v-for="(st, idx) in newRouteStops"
                          :key="st.StpID"
                          class="d-flex align-center px-2 py-1 mb-1 route-stop-item"
                          outlined
                          :class="{
                            'primary lighten-5': idx === 0,
                            'success lighten-5': idx === newRouteStops.length - 1,
                          }"
                        >
                          <v-icon small class="mr-2 drag-handle" color="grey"
                            >mdi-drag</v-icon
                          >
                          <v-chip
                            small
                            :color="
                              idx === 0
                                ? 'primary'
                                : idx === newRouteStops.length - 1
                                ? 'success'
                                : 'grey'
                            "
                            class="mr-2"
                            dark
                            >{{ idx + 1 }}</v-chip
                          >
                          <div class="flex-grow-1">
                            <div class="d-flex align-center">
                              <span class="font-weight-medium">{{ st.StpName }}</span>
                              <v-tooltip
                                bottom
                                v-if="idx === 0 || idx === newRouteStops.length - 1"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    x-small
                                    class="ml-2"
                                    :color="idx === 0 ? 'primary' : 'success'"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{
                                      idx === 0
                                        ? "mdi-flag-checkered"
                                        : "mdi-flag-outline"
                                    }}
                                  </v-icon>
                                </template>
                                <span>{{
                                  idx === 0 ? "Punto de partida" : "Punto final"
                                }}</span>
                              </v-tooltip>
                            </div>
                            <span class="caption grey--text"
                              >{{ st.StpLatitude.toFixed(6) }},
                              {{ st.StpLongitude.toFixed(6) }}</span
                            >
                          </div>
                          <v-btn
                            icon
                            x-small
                            color="red"
                            @click="removeNewRouteStop(st)"
                            :disabled="savingNewRoute"
                          >
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                        </v-sheet>
                        <v-sheet
                          v-if="newRouteStops.length === 0"
                          class="text-center pa-4"
                        >
                          <v-icon large color="grey lighten-1">mdi-map-marker-off</v-icon>
                          <p class="mt-2 grey--text">
                            Sin paraderos. Todos los paraderos del bus serán agregados
                            automáticamente al crear una nueva ruta.
                          </p>
                        </v-sheet>
                      </draggable>
                    </v-sheet>

                    <div class="d-flex justify-end mt-2" v-if="newRouteStops.length > 0">
                      <!-- <v-btn small text color="blue" @click="invertRouteOrder">
                        <v-icon left small>mdi-swap-vertical</v-icon>
                        Invertir orden
                      </v-btn> -->
                      <v-btn small text color="red" @click="clearAllStops" class="ml-2">
                        <v-icon left small>mdi-delete-sweep</v-icon>
                        Quitar todos
                      </v-btn>
                    </div>
                  </div>
                </v-form>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">
              <v-card outlined>
                <v-toolbar flat dense color="grey lighten-4">
                  <span style="font-size: 13px">Paraderos en Ruta</span>
                  <v-spacer />
                  <v-btn
                    icon
                    small
                    color="primary"
                    :disabled="!selectedRoute?.RotID"
                    @click="startAddStop"
                  >
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                  <!-- NUEVO: Botón para ver ruta en mapa -->
                  <v-btn
                    icon
                    small
                    color="green"
                    :disabled="!selectedRoute?.RotID || routeStops.length < 2"
                    @click="showRouteMap = true"
                  >
                    <v-icon small>mdi-map-marker-path</v-icon>
                  </v-btn>
                </v-toolbar>

                <!-- MODIFICADO: Reemplazar la tabla por componente draggable cuando hay ruta seleccionada -->
                <div v-if="selectedRoute?.RotID && !stopEdit" class="pa-2">
                  <v-alert dense type="info" class="mb-2" text>
                    <v-icon left small>mdi-information</v-icon>
                    Arrastra los paraderos para cambiar el orden o usa los controles para
                    ajustarlo manualmente.
                  </v-alert>
                  <draggable
                    v-model="routeStops"
                    group="routeStops"
                    handle=".drag-handle"
                    @end="onRouteDragEnd"
                    :animation="200"
                    ghost-class="ghost-route-stop"
                    class="route-stops-list"
                  >
                    <v-sheet
                      v-for="(stop, index) in routeStops"
                      :key="stop.BrsID"
                      outlined
                      rounded
                      class="mb-2 pa-2 route-stop-item"
                      :class="{
                        'primary lighten-5': index === 0,
                        'success lighten-5': index === routeStops.length - 1,
                      }"
                    >
                      <div class="d-flex align-center">
                        <v-icon class="mr-2 drag-handle" color="grey">mdi-drag</v-icon>
                        <v-chip
                          small
                          :color="
                            index === 0
                              ? 'primary'
                              : index === routeStops.length - 1
                              ? 'success'
                              : 'grey'
                          "
                          class="mr-2"
                          dark
                          >{{ index + 1 }}</v-chip
                        >
                        <div class="flex-grow-1">
                          <div class="font-weight-medium">{{ stop.StpName }}</div>
                          <div class="d-flex align-center">
                            <v-text-field
                              v-model.number="stop.BrsStopOrder"
                              type="number"
                              dense
                              hide-details
                              class="mr-2"
                              style="max-width: 65px"
                              @change="updateStopOrder(stop)"
                              label="Orden"
                            />
                            <v-text-field
                              v-model="stop.BrsEstimatedTime"
                              type="time"
                              dense
                              hide-details
                              style="max-width: 120px"
                              @change="updateStopTime(stop)"
                              label="Tiempo Est."
                            />
                            <v-spacer></v-spacer>
                            <v-btn
                              icon
                              x-small
                              :disabled="index === 0"
                              color="blue lighten-1"
                              class="mr-1"
                              @click="moveStop(stop, -1)"
                            >
                              <v-icon small>mdi-arrow-up-bold</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              x-small
                              :disabled="index === routeStops.length - 1"
                              color="blue lighten-1"
                              class="mr-1"
                              @click="moveStop(stop, 1)"
                            >
                              <v-icon small>mdi-arrow-down-bold</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              x-small
                              color="red"
                              @click="removeRouteStop(stop)"
                            >
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </v-sheet>
                    <!-- Mensaje cuando no hay paraderos -->
                    <v-sheet v-if="routeStops.length === 0" class="text-center pa-4">
                      <v-icon large color="grey lighten-1">mdi-map-marker-off</v-icon>
                      <p class="mt-2 grey--text">
                        Esta ruta no tiene paraderos. Haga clic en "+" para agregar un
                        paradero.
                      </p>
                    </v-sheet>
                  </draggable>

                  <!-- Botones para gestión masiva -->
                  <div v-if="routeStops.length > 1" class="d-flex justify-end mt-2">
                    <v-btn small text color="blue" @click="invertRouteOrder">
                      <v-icon left small>mdi-swap-vertical</v-icon>
                      Invertir orden
                    </v-btn>
                    <!-- <v-btn
                      small
                      text
                      color="indigo"
                      class="ml-2"
                      @click="reindexRouteStops(true)"
                    >
                      <v-icon left small>mdi-sort-numeric-ascending</v-icon>
                      Reindexar orden
                    </v-btn> -->
                  </div>
                </div>

                <!-- Mantener la tabla original como fallback y para compatibilidad -->
                <v-data-table
                  v-if="!selectedRoute?.RotID || stopEdit"
                  :headers="routeStopsHeaders"
                  :items="routeStops"
                  :item-key="'BrsID'"
                  dense
                  :loading="routeStopsLoading"
                  height="300"
                  :hide-default-footer="true"
                >
                  <template v-slot:item.BrsStopOrder="{ item }">
                    <div style="display: flex; align-items: center; gap: 4px">
                      <v-text-field
                        v-model.number="item.BrsStopOrder"
                        type="number"
                        dense
                        hide-details
                        style="max-width: 65px"
                        @change="updateStopOrder(item)"
                      />
                      <v-btn
                        icon
                        x-small
                        :disabled="isFirstStop(item)"
                        @click="moveStop(item, -1)"
                      >
                        <v-icon small>mdi-chevron-up</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        x-small
                        :disabled="isLastStop(item)"
                        @click="moveStop(item, 1)"
                      >
                        <v-icon small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <template v-slot:item.BrsEstimatedTime="{ item }">
                    <v-text-field
                      v-model="item.BrsEstimatedTime"
                      type="time"
                      dense
                      hide-details
                      style="max-width: 120px"
                      @change="updateStopTime(item)"
                    />
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon x-small color="red" @click="removeRouteStop(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <v-chip small color="grey lighten-3">Sin paraderos</v-chip>
                  </template>
                </v-data-table>

                <!-- Form agregar paradero -->
                <v-form ref="routeStopForm" class="pa-3" v-if="stopEdit">
                  <v-select
                    dense
                    outlined
                    label="Paradero"
                    :items="availableStops"
                    item-text="StpName"
                    item-value="StpID"
                    v-model="stopForm.StpID"
                    :disabled="availableStopsLoading"
                  />
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    label="Orden"
                    v-model.number="stopForm.BrsStopOrder"
                  />
                  <v-text-field
                    dense
                    outlined
                    type="time"
                    label="Tiempo Estimado"
                    v-model="stopForm.BrsEstimatedTime"
                  />
                  <v-btn
                    small
                    block
                    color="primary"
                    class="mt-2"
                    :disabled="!stopForm.StpID"
                    @click="saveRouteStop"
                    :loading="savingStop"
                  >
                    <v-icon left small>mdi-content-save</v-icon
                    >{{ stopForm.BrsID ? "Actualizar" : "Agregar" }}
                  </v-btn>
                  <v-btn small block text @click="cancelStopEdit">Cancelar</v-btn>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showRouteMap" max-width="800px" persistent>
      <bus-route-map
        :title="'Ruta: ' + (selectedRoute?.RotAlias || 'Sin nombre')"
        :stops="routeStops"
        :route-id="selectedRoute?.RotID"
        @close="showRouteMap = false"
        @error="handleRouteError"
      />
    </v-dialog>
  </div>
</template>

<script>
import _smonitoringBusService from "@/services/Management/MonitoringBusService.js";
import { LMap, LTileLayer, LMarker, LTooltip, LPolyline } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import draggable from "vuedraggable";
import BusRouteMap from "@/components/BusControl/BusRouteMap.vue";
import BusTurnAssignCrud from "@/views/HumanResource/BusControl/BusTurnAssignCrud.vue";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";

// Fix para los iconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPolyline,
    draggable,
    BusRouteMap,
    BusTurnAssignCrud,
    sToolbarPerson,
  },
  data() {
    return {
      configBus: {
        model: {
          BscID: "ID",
        },
        service: _smonitoringBusService,
        headers: [
          { text: "ID", value: "BscID" },
          { text: "Cod Empresa", value: "BscCompany" },
          // { text: "DNI", value: "BscDniDriver" },
          // { text: "Conductor", value: "BscNameDriver" },
          // { text: "Brevete", value: "BscLicense" },
          { text: "Placa", value: "BscLicencePlate" },
          { text: "Capacidad", value: "BscCapacity" },
          { text: "Ruta", value: "TypeRouteName" },
          { text: "Puerta Entrada", value: "TypeDoorName" },
          { text: "Costo Viaje", value: "BscCost" },
          { text: "Soat", value: "BscSoat" },
          { text: "Tarj. Prop", value: "BscPropertyCard" },
          { text: "Rev. Técni", value: "BscTechnicalReview" },
          {
            text: "Rutas",
            value: "actionsRoute",
            sortable: false,
            align: "center",
            width: 80,
          },
        ],
      },
      filter: {},
      selectedBusID: null,
      isEdit: false,
      showBusStopModal: false,
      savingBusStop: false,
      gettingLocation: false,
      busStop: {
        StpName: "",
        StpObservation: "",
        StpLatitude: null,
        StpLongitude: null,
      },
      mapCenter: [-5.19449, -80.63282], // Piura centro
      mapZoom: 15,
      mapKey: 0, // Para forzar re-render del mapa
      tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      mapOptions: {
        zoomControl: true,
        attributionControl: true,
        scrollWheelZoom: true,
        doubleClickZoom: true,
        boxZoom: true,
        keyboard: true,
        dragging: true,
        touchZoom: true,
      },
      customIcon: L.divIcon({
        className: "custom-bus-stop-marker",
        html:
          '<div style="background-color: #4CAF50; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3);"></div>',
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      }),

      /* Nuevo: estado de listado de paraderos */
      busStops: [],
      busStopsTotal: 0,
      busStopsLoading: false,
      busStopsPage: 1,
      busStopsItemsPerPage: 10,
      busStopsSearch: "",
      busStopsHeaders: [
        { text: "ID", value: "StpID", width: 70 },
        { text: "Nombre", value: "StpName" },
        { text: "Latitud", value: "StpLatitude" },
        { text: "Longitud", value: "StpLongitude" },
        { text: "Observación", value: "StpObservation" },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: 110,
        },
      ],
      debounceTimer: null,

      /* Nuevo: estado de listado de conductores */
      busDrivers: [],
      busDriversLoading: false,
      busDriversHeaders: [
        { text: "DNI", value: "PrsDocumentNumber" },
        { text: "Nombre", value: "PrsFullName" },
        { text: "Número de Licencia", value: "BdrLicenseNumber" },
        { text: "Acciones", value: "actions", sortable: false, align: "center", width: 130 },
      ],
      showDriverModal: false,
      newDriver: { 
        PrsID: null, 
        PrsDocumentNumber: "", 
        PrsFullName: "" ,
        BdrLicenseNumber: ""
      },
      savingDriver: false,
      showMoveDriverModal: false,
      driverToMove: null,
      targetBusID: null,
      busesList: [],
      movingDriver: false,

      /* Gestión de rutas */
      showRouteModal: false,
      currentBus: null,
      routes: [],
      routesLoading: false,
      routeHeaders: [
        { text: "Alias", value: "RotAlias" },
        { text: "Inicio", value: "RotStartDate" },
        { text: "Fin", value: "RotEndDate" },
        { text: "Acc.", value: "actions", sortable: false, align: "center", width: 90 },
      ],
      routeForm: { RotID: 0, RotAlias: "", RotStartDate: null, RotEndDate: null },
      routeEdit: false,
      selectedRoute: null,
      savingRoute: false,
      menuStart: false,
      menuEnd: false,

      /* Stops en ruta */
      routeStops: [],
      routeStopsLoading: false,
      routeStopsHeaders: [
        { text: "Paradero", value: "StpName" },
        { text: "Orden", value: "BrsStopOrder" },
        { text: "Tiempo Est.", value: "BrsEstimatedTime" },
        { text: "Acc.", value: "actions", sortable: false, align: "center", width: 70 },
      ],
      stopEdit: false,
      stopForm: { BrsID: 0, StpID: null, BrsStopOrder: 1, BrsEstimatedTime: null },
      savingStop: false,
      availableStops: [],
      availableStopsLoading: false,

      /* Nuevo: mostrar inactivos */
      showInactiveStops: false,

      /* Nuevo: estado de guardado en bloque */
      savingRouteStopsBulk: false,

      /* NUEVO: staging paraderos para ruta nueva */
      newRouteStops: [],
      savingNewRoute: false, // NUEVO: estado guardado ruta+paraderos

      /* NUEVO: mapeo y visualización de ruta */
      showRouteMap: false,
      startIcon: L.divIcon({
        className: "custom-start-marker",
        html:
          '<div style="background-color: #4CAF50; width: 32px; height: 32px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;"><span style="color: white; font-weight: bold;">I</span></div>',
        iconSize: [32, 32],
        iconAnchor: [16, 16],
      }),
      endIcon: L.divIcon({
        className: "custom-end-marker",
        html:
          '<div style="background-color: #f44336; width: 32px; height: 32px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;"><span style="color: white; font-weight: bold;">F</span></div>',
        iconSize: [32, 32],
        iconAnchor: [16, 16],
      }),
      stopIcon: L.divIcon({
        className: "custom-stop-marker",
        html:
          '<div style="background-color: #2196F3; width: 24px; height: 24px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3);"></div>',
        iconSize: [24, 24],
        iconAnchor: [12, 12],
      }),
    };
  },
  watch: {
    busStopsPage() {
      this.fetchBusStops();
    },
    busStopsItemsPerPage() {
      this.fetchBusStops();
    },
    busStopsSearch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.resetAndFetchBusStops(), 400);
    },
    selectedBusID() {
      this.resetAndFetchBusStops();
    },
    showInactiveStops() {
      this.resetAndFetchBusStops();
    },
  },
  computed: {
    // Nuevo: cadena mostrada en el modal de rutas
    currentBusDisplay() {
      if (!this.currentBus) return "-";
      const placa = this.currentBus.BscLicencePlate || "";
      const empresa = this.currentBus.BscCompany || "";
      return [placa, empresa].filter((x) => x).join(" - ") || "-";
    },
    sortedStops() {
      return [...this.routeStops].sort(
        (a, b) => (a.BrsStopOrder || 0) - (b.BrsStopOrder || 0)
      );
    },
  },
  methods: {
    hadReturnPerson(value, item) {
      if (value) {
        item.BscDniDriver = value.PrsDocumentNumber;
        item.BscNameDriver = value.PrsFullName;
      }
    },
    handleRouteError(message) {
      this.$fun.alert(message, "error");
    },
    save(items) {
      items.UsrCreateID = this.$fun.getUserID();
      items.UsrUpdateID = this.$fun.getUserID();
      items.save();
    },
    editEvent(items) {
      this.isEdit = true;
    },
    openNewBusStop() {
      if (!this.selectedBusID) {
        this.$fun.alert("Seleccione un bus primero", "warning");
        return;
      }
      this.busStop = {
        StpID: 0,
        StpName: "",
        StpObservation: "",
        StpLatitude: null,
        StpLongitude: null,
        UsrCreateID: this.$fun.getUserID(),
      };
      this.showBusStopModal = true;
      this.mapCenter = [-5.19449, -80.63282]; //coordenadas piura
      this.busStop.UsrCreateID = this.$fun.getUserID();
    },
    openEditBusStop(item) {
      this.busStop = {
        StpID: item.StpID,
        StpName: item.StpName,
        StpObservation: item.StpObservation,
        StpLatitude: item.StpLatitude,
        StpLongitude: item.StpLongitude,
      };
      this.showBusStopModal = true;
      this.mapCenter = [item.StpLatitude || -5.19449, item.StpLongitude || -80.63282];
      this.$nextTick(() => this.onMapReady());
      this.busStop.UsrUpdateID = this.$fun.getUserID();
    },
    deleteBusStop(item) {
      this.$fun.alert("¿Eliminar paradero?", "question").then((r) => {
        if (r.value) {
          _smonitoringBusService
            .deleteBusStop(item.StpID, this.$fun.getUserID(), this.$fun.getUserID())
            .then((resp) => {
              if (resp.status === 200) {
                this.$fun.alert("Eliminado correctamente", "success");
                this.fetchBusStops();
              } else {
                this.$fun.alert("Error al eliminar", "error");
              }
            })
            .catch(() => this.$fun.alert("Error al eliminar", "error"));
        }
      });
    },
    saveBusStopModal() {
      if (
        !this.busStop.StpName /* ||
        !this.busStop.StpLatitude ||
        !this.busStop.StpLongitude */
      ) {
        this.$fun.alert("Complete los campos requeridos", "warning");
        return;
      }
      if (!this.selectedBusID) {
        this.$fun.alert("Seleccione un bus", "warning");
        return;
      }
      const isEdit = !!this.busStop.StpID;
      const data = {
        ...this.busStop,
        BscID: this.selectedBusID,
        UsrCreateID: !isEdit ? this.$fun.getUserID() : undefined,
        UsrUpdateID: isEdit ? this.$fun.getUserID() : undefined,
      };
      this.savingBusStop = true;
      const request = isEdit
        ? _smonitoringBusService.updateBusStop(data, this.$fun.getUserID())
        : _smonitoringBusService.createBusStop(data, this.$fun.getUserID());
      request
        .then((resp) => {
          if (resp.status === 200) {
            this.$fun.alert(
              isEdit ? "Actualizado correctamente" : "Paradero registrado correctamente",
              "success"
            );
            this.closeBusStopModal();
            this.fetchBusStops();
          } else this.$fun.alert("Error al guardar", "error");
        })
        .catch(() => this.$fun.alert("Error al guardar", "error"))
        .finally(() => (this.savingBusStop = false));
    },
    resetAndFetchBusStops() {
      this.busStopsPage = 1;
      if (this.selectedBusID) {
        this.fetchBusStops();
        this.fetchBusDrivers();
      } else {
        this.busStops = [];
        this.busStopsTotal = 0;
        this.busDrivers = [];
      }
    },
    fetchBusDrivers() {
      if (!this.selectedBusID) return;
      this.busDriversLoading = true;
      _smonitoringBusService
        .getBusDrivers(this.selectedBusID, this.$fun.getUserID())
        .then((r) => {
          this.busDrivers = r.data || [];
        })
        .finally(() => (this.busDriversLoading = false));
    },
    openDriverModal() {
      this.newDriver = {
        BdrID: null,
        PrsID: null,
        PrsDocumentNumber: "",
        PrsFullName: "",
        BdrLicenseNumber: "",
      };
      this.showDriverModal = true;
    },
    openEditDriver(item) {
      this.newDriver = {
        BdrID: item.BdrID,
        PrsID: item.PrsID,
        PrsDocumentNumber: item.PrsDocumentNumber,
        PrsFullName: item.PrsFullName,
        BdrLicenseNumber: item.BdrLicenseNumber,
      };
      this.showDriverModal = true;
    },
    closeDriverModal() {
      this.showDriverModal = false;
      this.newDriver = {
        BdrID: null,
        PrsID: null,
        PrsDocumentNumber: "",
        PrsFullName: "",
        BdrLicenseNumber: "",
      };
    },
    onDriverSelected(person) {
      if (person) {
        this.newDriver.PrsID = person.PrsID;
        this.newDriver.PrsDocumentNumber = person.PrsDocumentNumber;
        this.newDriver.PrsFullName = person.NtpFullName;
      } else {
        // Mantener BdrID si estamos editando
        const currentBdrID = this.newDriver.BdrID;
        this.newDriver = {
          BdrID: currentBdrID,
          PrsID: null,
          PrsDocumentNumber: "",
          PrsFullName: "",
          BdrLicenseNumber: "",
        };
      }
    },
    saveBusDriver() {
      if (!this.newDriver.PrsID) return;
      if (
        !this.newDriver.BdrLicenseNumber ||
        this.newDriver.BdrLicenseNumber.trim() === ""
      ) {
        this.$fun.alert("Ingrese el número de licencia del conductor", "warning");
        return;
      }
      this.savingDriver = true;
      const isUpdate = !!this.newDriver.BdrID;
      const payload = {
        BscID: this.selectedBusID,
        PrsID: this.newDriver.PrsID,
        BdrLicenseNumber: this.newDriver.BdrLicenseNumber.trim(),
      };

      if (isUpdate) payload.BdrID = this.newDriver.BdrID;
      const request = _smonitoringBusService.saveBusDriver(payload, this.$fun.getUserID());

      request
        .then((resp) => {
          if (resp.status === 200) {
            this.$fun.alert(
              isUpdate
                ? "Conductor actualizado correctamente"
                : "Conductor agregado correctamente",
              "success"
            );
            this.closeDriverModal();
            this.fetchBusDrivers();
          } else {
            // Mostrar el mensaje de error específico que viene del backend
            const msg =
              resp.data && resp.data.Message
                ? resp.data.Message
                : "Error al guardar conductor";
            this.$fun.alert(msg, "warning");
          }
        })
        .catch((err) => {
          // Capturar mensaje de error del catch si el status no es 200
          const msg =
            err.response && err.response.data && err.response.data.Message
              ? err.response.data.Message
              : "Error al guardar conductor";
          this.$fun.alert(msg, "warning");
        })
        .finally(() => (this.savingDriver = false));
    },
    openMoveDriverModal(item) {
      this.driverToMove = item;
      this.targetBusID = null;
      this.showMoveDriverModal = true;
      this.loadBusesList();
    },
    closeMoveDriverModal() {
      this.showMoveDriverModal = false;
      this.driverToMove = null;
      this.targetBusID = null;
    },
    loadBusesList() {
      // Usaremos pagination con limit alto para traer todos los buses disponibles
      const dtr = {
        filter: {},
        draw: 1,
        start: 0,
        length: 2000,
        order: [{ column: "BscLicencePlate", dir: "asc" }],
        searchText: "",
      };
      _smonitoringBusService.pagination(dtr, this.$fun.getUserID()).then((r) => {
        const rows = r.data && (r.data.data || r.data.rows) ? (r.data.data || r.data.rows) : [];
        // Filtrar el bus actual
        this.busesList = rows.filter((b) => b.BscID !== this.selectedBusID);
      });
    },
    saveMoveDriver() {
      if (!this.targetBusID) {
        this.$fun.alert("Seleccione el bus de destino", "warning");
        return;
      }
      if (this.targetBusID === this.selectedBusID) {
        this.$fun.alert(
          "El bus de destino debe ser diferente al actual",
          "warning"
        );
        return;
      }

      this.movingDriver = true;
      const payload = {
        BdrID: this.driverToMove.BdrID,
        TargetBscID: this.targetBusID,
      };

      _smonitoringBusService
        .moveBusDriver(payload, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status === 200) {
            this.$fun.alert("Conductor movido correctamente", "success");
            this.closeMoveDriverModal();
            this.fetchBusDrivers(); // Refrescar lista actual (el conductor deberia desaparecer)
          } else {
            const msg =
              resp.data && resp.data.Message
                ? resp.data.Message
                : "Error al mover conductor";
            this.$fun.alert(msg, "warning");
          }
        })
        .catch((err) => {
          const msg =
            err.response && err.response.data && err.response.data.Message
              ? err.response.data.Message
              : "Error al mover conductor";
          this.$fun.alert(msg, "warning");
        })
        .finally(() => (this.movingDriver = false));
    },
    deleteBusDriver(item) {
      this.$fun.alert("¿Eliminar conductor?", "question").then((r) => {
        if (r.value) {
          _smonitoringBusService
            .deleteBusDriver(item.BdrID, this.$fun.getUserID())
            .then((resp) => {
              if (resp.status === 200) {
                this.$fun.alert("Conductor eliminado", "success");
                this.fetchBusDrivers();
              } else {
                this.$fun.alert("Error al eliminar conductor", "error");
              }
            });
        }
      });
    },
    fetchBusStops() {
      if (!this.selectedBusID) {
        return;
      }

      this.busStopsLoading = true;
      const dtr = {
        filter: {
          BscID: this.selectedBusID,
          IncludeInactive: this.showInactiveStops ? 1 : 0,
        },
        draw: 1,
        start: (this.busStopsPage - 1) * this.busStopsItemsPerPage,
        length: this.busStopsItemsPerPage,
        order: [{ column: "StpID", dir: "desc" }],
        searchText: this.busStopsSearch || "",
      };
      _smonitoringBusService
        .getBusStops(dtr, this.$fun.getUserID())
        .then((r) => {
          const payload = r.data;
          const rows = payload.data || payload.rows || payload || [];
          this.busStops = Array.isArray(rows) ? rows : [];
          this.busStopsTotal =
            payload.recordsTotal != null ? payload.recordsTotal : this.busStops.length;
          if (this.busStops.length === 0 && !this.showInactiveStops) {
            console.info(
              'No hay paraderos activos. Prueba activar "Mostrar inactivos" para verificar eliminados lógicamente.'
            );
          }
        })
        .catch((err) => {
          console.error("Error listando paraderos", err);
          this.$fun.alert("Error al listar paraderos", "error");
          this.busStops = [];
        })
        .finally(() => (this.busStopsLoading = false));
    },
    closeBusStopModal() {
      this.showBusStopModal = false;
      // Resetear el formulario
      this.busStop = {
        StpName: "",
        StpObservation: "",
        StpLatitude: null,
        StpLongitude: null,
      };
      // Resetear el mapa
      this.mapCenter = [-5.19449, -80.63282];
      this.mapZoom = 15;
    },
    onBusSelected(items) {
      const bus = Array.isArray(items) ? items[0] : items;
      this.selectedBusID = bus && bus.BscID ? bus.BscID : null;
      this.filterBusStop = this.selectedBusID ? { BscID: this.selectedBusID } : {};
      this.resetAndFetchBusStops();
    },
    handleMapClick(e) {
      // vue2-leaflet click event: e.latlng
      if (e && e.latlng) {
        this.busStop.StpLatitude = parseFloat(e.latlng.lat.toFixed(6));
        this.busStop.StpLongitude = parseFloat(e.latlng.lng.toFixed(6));
      }
    },
    onMapReady() {
      // Forzar que el mapa se redimensione correctamente
      this.$nextTick(() => {
        if (this.$refs.map && this.$refs.map.mapObject) {
          setTimeout(() => {
            this.$refs.map.mapObject.invalidateSize();
          }, 100);
        }
      });
    },
    onDialogToggle(isOpen) {
      if (isOpen) {
        // Cuando se abre el diálogo, incrementar la key para forzar re-render
        this.mapKey++;
        this.$nextTick(() => {
          // Esperar un poco más y redimensionar el mapa
          setTimeout(() => {
            if (this.$refs.map && this.$refs.map.mapObject) {
              this.$refs.map.mapObject.invalidateSize();
            }
          }, 300);
        });
      }
    },
    getCurrentLocation() {
      if ("geolocation" in navigator) {
        this.gettingLocation = true;
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.busStop.StpLatitude = parseFloat(position.coords.latitude.toFixed(6));
            this.busStop.StpLongitude = parseFloat(position.coords.longitude.toFixed(6));

            // Centrar el mapa en la ubicación actual
            this.mapCenter = [this.busStop.StpLatitude, this.busStop.StpLongitude];
            this.mapZoom = 18;

            this.$nextTick(() => {
              if (this.$refs.map && this.$refs.map.mapObject) {
                this.$refs.map.mapObject.setView(
                  [this.busStop.StpLatitude, this.busStop.StpLongitude],
                  18
                );
              }
            });

            this.gettingLocation = false;
            this.$fun.alert("Ubicación obtenida correctamente", "success");
          },
          (error) => {
            this.gettingLocation = false;
            let errorMessage = "Error al obtener la ubicación";
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = "Permisos de ubicación denegados";
                break;
              case error.POSITION_UNAVAILABLE:
                errorMessage = "Ubicación no disponible";
                break;
              case error.TIMEOUT:
                errorMessage = "Timeout al obtener ubicación";
                break;
            }
            this.$fun.alert(errorMessage, "error");
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 60000,
          }
        );
      } else {
        this.$fun.alert("Geolocalización no disponible en este navegador", "error");
      }
    },

    /* Métodos para gestión de rutas */
    openRouteManager(bus) {
      // FIX: validar parámetro
      if (!bus) {
        this.$fun.alert("No se pudo obtener el bus", "warning");
        return;
      }
      this.currentBus = bus;
      this.showRouteModal = true;
      this.resetRouteState();
      this.loadRoutes();
      this.loadAvailableStops(); // para futuras altas
    },
    closeRouteModal() {
      this.showRouteModal = false;
      this.currentBus = null;
      this.selectedRoute = null;
    },
    resetRouteState() {
      this.routeEdit = false;
      this.routeForm = {
        RotID: 0,
        RotAlias: "",
        RotStartDate: null,
        RotEndDate: null,
        BscID: this.currentBus?.BscID,
      };
      this.stopEdit = false;
      this.stopForm = { BrsID: 0, StpID: null, BrsStopOrder: 1, BrsEstimatedTime: null };
      this.routeStops = [];
      this.newRouteStops = []; // NUEVO: staging paraderos para ruta nueva
    },
    loadRoutes() {
      if (!this.currentBus) return;
      this.routesLoading = true;
      _smonitoringBusService
        .getBusRoutesByBus(this.currentBus.BscID, this.$fun.getUserID())
        .then((r) => {
          this.routes = r.data || [];
        })
        .finally(() => (this.routesLoading = false));
    },
    startNewRoute() {
      this.routeEdit = true;
      this.routeForm = {
        RotID: 0,
        RotAlias: "",
        RotStartDate: this.$moment().format("YYYY-MM-DD"),
        RotEndDate: null,
        BscID: this.currentBus.BscID,
      };
      this.newRouteStops = [];
      this.loadBusStopsForNewRoute();
    },
    loadBusStopsForNewRoute() {
      // Mejorar para mostrar progreso de carga
      //   this.$fun.loading(true, "Cargando paraderos...");
      const dtr = {
        filter: { BscID: this.currentBus.BscID, IncludeInactive: 0 },
        start: 0,
        length: 1000,
        draw: 1,
        order: [{ column: "StpID", dir: "asc" }],
        searchText: "",
      };
      _smonitoringBusService
        .getBusStops(dtr, this.$fun.getUserID())
        .then((r) => {
          const rows = (r.data && (r.data.data || r.data)) || [];
          this.newRouteStops = rows
            .filter((x) => x.SecStatus === 1)
            .map((x, i) => ({
              StpID: x.StpID,
              StpName: x.StpName,
              StpLatitude: x.StpLatitude,
              StpLongitude: x.StpLongitude,
              order: i + 1,
            }));
          if (this.newRouteStops.length > 0) {
            this.$fun.alert(
              `Se cargaron ${this.newRouteStops.length} paraderos. Organícelos en el orden deseado del recorrido.`,
              "success"
            );
          } else {
            this.$fun.alert(
              "No hay paraderos disponibles para este bus. Agregue paraderos primero.",
              "warning"
            );
          }
        })
        .catch((err) => {
          console.error("Error cargando paraderos:", err);
          this.$fun.alert("Error al cargar paraderos", "error");
        })
        .finally(() => {
          //   this.$fun.loading(false);
        });
    },
    onNewRouteDragEnd() {
      // Reindexar orden después de drag
      this.newRouteStops.forEach((s, i) => (s.order = i + 1));
    },
    removeNewRouteStop(stop) {
      this.newRouteStops = this.newRouteStops.filter((s) => s.StpID !== stop.StpID);
      this.onNewRouteDragEnd();
    },
    invertRouteOrder() {
      this.$fun
        .alert(
          "¿Invertir el orden de los paraderos?<br><small>Útil para crear rutas de regreso</small>",
          "question"
        )
        .then((result) => {
          if (result.isConfirmed) {
            // Invertir y reindexar
            this.newRouteStops = [...this.newRouteStops].reverse();
            this.newRouteStops.forEach((s, i) => (s.order = i + 1));

            // Si estamos editando una ruta existente, invertir y guardar
            if (this.selectedRoute?.RotID && this.routeStops.length > 1) {
              const reversedStops = [...this.routeStops].reverse();
              reversedStops.forEach((s, i) => (s.BrsStopOrder = i + 1));

              // Guardar el nuevo orden
              const payload = reversedStops.map((s) => ({
                BrsID: s.BrsID,
                BrsStopOrder: s.BrsStopOrder,
              }));
              _smonitoringBusService
                .reorderRouteStops(
                  this.selectedRoute.RotID,
                  payload,
                  this.$fun.getUserID()
                )
                .then((r) => {
                  if (r.status === 200) {
                    this.$fun.alert("Orden invertido correctamente", "success");
                    this.routeStops = reversedStops;
                  } else {
                    this.$fun.alert("Error al guardar nuevo orden", "error");
                  }
                })
                .catch(() => this.$fun.alert("Error de conexión", "error"));
            }
          }
        });
    },
    async saveNewRouteFull() {
      if (!this.routeForm.RotAlias) {
        this.$fun.alert("Alias requerido", "warning");
        return;
      }
      if (this.newRouteStops.length === 0) {
        this.$fun.alert("No hay paraderos para guardar", "warning");
        return;
      }
      this.savingNewRoute = true;
      try {
        // 1. Crear ruta
        const respRoute = await _smonitoringBusService.createBusRoute(
          this.routeForm,
          this.$fun.getUserID()
        );
        if (respRoute.status !== 200) {
          this.$fun.alert("Error creando ruta", "error");
          this.savingNewRoute = false;
          return;
        }
        const newRotID =
          (respRoute.data && respRoute.data.RotID) || respRoute.data || null;
        if (!newRotID) {
          this.$fun.alert("No se obtuvo ID de la ruta", "error");
          this.savingNewRoute = false;
          return;
        }
        // 2. Insertar paraderos en orden
        for (const s of this.newRouteStops) {
          const payload = {
            StpID: s.StpID,
            BrsStopOrder: s.order,
            BrsEstimatedTime: null,
          };
          console.log("Agregando paradero a ruta:", payload);

          const addResp = await _smonitoringBusService.addRouteStop(
            newRotID,
            payload,
            this.$fun.getUserID()
          );
          if (addResp.status !== 200) {
            this.$fun.alert(
              "Error agregando un paradero (se detuvo el proceso)",
              "error"
            );
            break;
          }
        }
        this.$fun.alert("Ruta y paraderos guardados", "success");
        this.routeEdit = false;
        this.loadRoutes();
      } catch (e) {
        console.error(e);
        this.$fun.alert("Error guardando ruta y paraderos", "error");
      } finally {
        this.savingNewRoute = false;
      }
    },
    // (edición de ruta existente se mantiene igual)
    editRoute(route) {
      this.routeEdit = true;
      this.routeForm = { ...route, BscID: this.currentBus.BscID };
    },
    cancelRouteEdit() {
      this.routeEdit = false;
      this.routeForm = {
        RotID: 0,
        RotAlias: "",
        RotStartDate: null,
        RotEndDate: null,
        BscID: this.currentBus.BscID,
      };
    },
    saveRoute() {
      this.savingRoute = true;
      const payload = { ...this.routeForm, BscID: this.currentBus.BscID };
      const req = payload.RotID
        ? _smonitoringBusService.updateBusRoute(
            payload.RotID,
            payload,
            this.$fun.getUserID()
          )
        : _smonitoringBusService.createBusRoute(payload, this.$fun.getUserID());
      req
        .then((resp) => {
          if (resp.status === 200) {
            this.$fun.alert(
              payload.RotID ? "Ruta actualizada" : "Ruta creada",
              "success"
            );
            this.cancelRouteEdit();
            this.loadRoutes();
          } else this.$fun.alert("Error ruta", "error");
        })
        .finally(() => (this.savingRoute = false));
    },
    deleteRoute(route) {
      this.$fun.alert("¿Eliminar ruta?", "question").then((v) => {
        if (v.value) {
          _smonitoringBusService
            .deleteBusRoute(route.RotID, this.$fun.getUserID())
            .then((resp) => {
              if (resp.status === 200) {
                this.$fun.alert("Ruta eliminada", "success");
                if (this.selectedRoute?.RotID === route.RotID) {
                  this.selectedRoute = null;
                  this.routeStops = [];
                }
                this.loadRoutes();
              } else this.$fun.alert("Error eliminando ruta", "error");
            });
        }
      });
    },
    selectRoute(route) {
      this.selectedRoute = route;
      this.loadRouteStops();
    },
    loadRouteStops() {
      if (!this.selectedRoute) return;
      this.routeStopsLoading = true;
      _smonitoringBusService
        .getRouteStops(this.selectedRoute.RotID, this.$fun.getUserID())
        .then((r) => {
          // Procesamiento mejorado de los datos para asegurar coordenadas válidas
          this.routeStops = (r.data || [])
            .map((stop) => {
              // Convertir a números y validar
              if (stop.StpLatitude && stop.StpLongitude) {
                stop.StpLatitude = parseFloat(stop.StpLatitude);
                stop.StpLongitude = parseFloat(stop.StpLongitude);

                // Validar que sean números y estén en rangos válidos
                if (
                  isNaN(stop.StpLatitude) ||
                  isNaN(stop.StpLongitude) ||
                  Math.abs(stop.StpLatitude) > 90 ||
                  Math.abs(stop.StpLongitude) > 180
                ) {
                  console.warn(
                    `Coordenadas inválidas para parada ${stop.StpName}: [${stop.StpLatitude}, ${stop.StpLongitude}]`
                  );
                  stop.StpLatitude = null;
                  stop.StpLongitude = null;
                }
              } else {
                console.warn(`Parada sin coordenadas: ${stop.StpName || stop.StpID}`);
              }
              return stop;
            })
            .sort((a, b) => (a.BrsStopOrder || 0) - (b.BrsStopOrder || 0));
        })
        .catch((error) => {
          console.error("Error al cargar paradas de ruta:", error);
          this.$fun.alert("Error al cargar paradas de ruta", "error");
          this.routeStops = [];
        })
        .finally(() => (this.routeStopsLoading = false));
    },
    startAddStop() {
      if (!this.selectedRoute) {
        this.$fun.alert("Seleccione una ruta", "warning");
        return;
      }
      this.stopEdit = true;
      this.stopForm = {
        BrsID: 0,
        StpID: null,
        BrsStopOrder: this.routeStops.length + 1,
        BrsEstimatedTime: null,
      };
      this.loadAvailableStops();
    },
    cancelStopEdit() {
      this.stopEdit = false;
      this.stopForm = { BrsID: 0, StpID: null, BrsStopOrder: 1, BrsEstimatedTime: null };
    },
    loadAvailableStops() {
      if (!this.currentBus) return;
      this.availableStopsLoading = true;
      const dtr = {
        filter: { BscID: this.currentBus.BscID },
        start: 0,
        length: 1000,
        draw: 1,
        order: [{ column: "StpID", dir: "asc" }],
      };
      _smonitoringBusService
        .getBusStops(dtr, this.$fun.getUserID())
        .then((r) => {
          const rows = r.data.data || r.data || [];
          const used = new Set(this.routeStops.map((s) => s.StpID));
          this.availableStops = rows.filter((x) => !used.has(x.StpID));
        })
        .finally(() => (this.availableStopsLoading = false));
    },
    saveRouteStop() {
      if (!this.selectedRoute) return;
      this.savingStop = true;
      const payload = { ...this.stopForm };
      const req = payload.BrsID
        ? _smonitoringBusService.updateRouteStop(
            this.selectedRoute.RotID,
            payload.BrsID,
            payload,
            this.$fun.getUserID()
          )
        : _smonitoringBusService.addRouteStop(
            this.selectedRoute.RotID,
            payload,
            this.$fun.getUserID()
          );
      req
        .then((resp) => {
          if (resp.status === 200) {
            this.$fun.alert(
              payload.BrsID ? "Paradero actualizado" : "Paradero agregado",
              "success"
            );
            this.cancelStopEdit();
            this.loadRouteStops();
            this.loadAvailableStops();
          } else this.$fun.alert("Error guardando paradero", "error");
        })
        .finally(() => (this.savingStop = false));
    },

    /* MEJORADO: Al remover un paradero, reordenar automáticamente */
    removeRouteStop(item) {
      this.$fun.alert("¿Eliminar paradero de la ruta?", "question").then((r) => {
        if (r.value) {
          if (item.BrsID === 0) {
            // Si es un paradero no guardado, solo quitar de la lista local
            this.routeStops = this.routeStops.filter((s) => s !== item);
            this.reindexRouteStops(); // Reindexar automáticamente
          } else {
            // Si es un paradero guardado en BD, hacer la eliminación lógica
            _smonitoringBusService
              .deleteRouteStop(
                this.selectedRoute.RotID,
                item.BrsID,
                this.$fun.getUserID()
              )
              .then((resp) => {
                if (resp.status === 200) {
                  this.$fun.alert("Paradero eliminado de la ruta", "success");
                  this.loadRouteStops().finally(() => {
                    this.reindexRouteStops(); // Reindexar automáticamente tras recargar
                  });
                } else {
                  this.reindexRouteStops();
                }
              })
              .catch(() => this.$fun.alert("Error de conexión", "error"));
          }
        }
      });
    },

    /* NUEVO: Reindexar automáticamente los paraderos */
    reindexRouteStops() {
      if (this.routeStops.length === 0) return;

      // Ordenar por orden actual y reasignar índices consecutivos
      const orderedStops = [...this.routeStops].sort(
        (a, b) => (a.BrsStopOrder || 0) - (b.BrsStopOrder || 0)
      );
      // Asignar nuevos índices consecutivos
      orderedStops.forEach((stop, index) => {
        stop.BrsStopOrder = index + 1;
      });

      // Guardar cambios en servidor si hay una ruta seleccionada con ID
      if (this.selectedRoute?.RotID) {
        const payload = orderedStops.map((s) => ({
          BrsID: s.BrsID,
          BrsStopOrder: s.BrsStopOrder,
        }));
        _smonitoringBusService
          .reorderRouteStops(this.selectedRoute.RotID, payload, this.$fun.getUserID())
          .then((r) => {
            if (r.status !== 200) this.$fun.alert("Error guardando orden", "error");
          });
      }

      // Actualizar la lista local
      this.routeStops = [...orderedStops];
    },

    /* NUEVO: Métodos para visualización de mapa de ruta */
    getRouteCenter() {
      // Si no hay paradas, centro por defecto (Piura)
      if (!this.routeStops || this.routeStops.length === 0) return [-5.19449, -80.63282];

      // Filtrar paradas con coordenadas válidas
      const validStops = this.sortedStops.filter(
        (stop) =>
          stop &&
          stop.StpLatitude &&
          stop.StpLongitude &&
          !isNaN(parseFloat(stop.StpLatitude)) &&
          !isNaN(parseFloat(stop.StpLongitude)) &&
          Math.abs(parseFloat(stop.StpLatitude)) <= 90 &&
          Math.abs(parseFloat(stop.StpLongitude)) <= 180
      );

      if (validStops.length === 0) return [-5.19449, -80.63282];

      // Calcular el centro
      let totalLat = 0;
      let totalLng = 0;

      validStops.forEach((stop) => {
        totalLat += parseFloat(stop.StpLatitude);
        totalLng += parseFloat(stop.StpLongitude);
      });

      return [totalLat / validStops.length, totalLng / validStops.length];
    },

    getRoutePoints() {
      return this.sortedStops
        .filter(
          (stop) =>
            stop.StpLatitude &&
            stop.StpLongitude &&
            !isNaN(parseFloat(stop.StpLatitude)) &&
            !isNaN(parseFloat(stop.StpLongitude)) &&
            Math.abs(parseFloat(stop.StpLatitude)) <= 90 &&
            Math.abs(parseFloat(stop.StpLongitude)) <= 180
        )
        .map((stop) => [parseFloat(stop.StpLatitude), parseFloat(stop.StpLongitude)]);
    },

    getStopIcon(index) {
      if (index === 0) return this.startIcon;
      if (index === this.sortedStops.length - 1) return this.endIcon;
      return this.stopIcon;
    },

    onRouteMapReady() {
      this.$nextTick(() => {
        if (this.$refs.routeMap && this.$refs.routeMap.mapObject) {
          setTimeout(() => {
            this.$refs.routeMap.mapObject.invalidateSize();

            // Ajustar zoom para mostrar todos los puntos si hay puntos válidos
            const points = this.getRoutePoints();
            if (points && points.length > 1) {
              try {
                const bounds = L.latLngBounds(points);
                this.$refs.routeMap.mapObject.fitBounds(bounds, {
                  padding: [50, 50],
                  maxZoom: 15,
                });
              } catch (error) {
                console.error("Error al ajustar el mapa a los puntos:", error);
                // Centrar en un punto predeterminado
                this.$refs.routeMap.mapObject.setView([-5.19449, -80.63282], 13);
              }
            } else {
              // Si no hay puntos válidos, centrar en un punto predeterminado
              this.$refs.routeMap.mapObject.setView([-5.19449, -80.63282], 13);
            }
          }, 300);
        }
      });
    },
    isFirstStop(index) {
      return index === 0;
    },
    isLastStop(index) {
      return index === this.sortedStops.length - 1;
    },
    updateStopOrder(index, newOrder) {
      if (newOrder < 1 || newOrder > this.sortedStops.length) return;
      const stop = this.sortedStops[index];
      if (!stop) return;

      // Actualizar el orden localmente
      stop.BrsStopOrder = newOrder;

      // Reindexar todos los paraderos
      this.reindexRouteStops();

      // Guardar cambios en servidor si hay una ruta seleccionada con ID
      if (this.selectedRoute?.RotID) {
        const payload = this.sortedStops.map((s) => ({
          BrsID: s.BrsID,
          BrsStopOrder: s.BrsStopOrder,
        }));
        _smonitoringBusService
          .reorderRouteStops(this.selectedRoute.RotID, payload, this.$fun.getUserID())
          .then((r) => {
            if (r.status !== 200) this.$fun.alert("Error guardando orden", "error");
          });
      }
    },
    // onRouteDragEnd - Método para manejar el final de un arrastre en ruta
    onRouteDragEnd() {
      this.routeStops.forEach((stop, index) => {
        stop.BrsStopOrder = index + 1;
      });

      // Guardar los cambios en el servidor
      if (this.selectedRoute?.RotID) {
        const payload = this.routeStops.map((s) => ({
          BrsID: s.BrsID,
          BrsStopOrder: s.BrsStopOrder,
        }));

        _smonitoringBusService
          .reorderRouteStops(this.selectedRoute.RotID, payload, this.$fun.getUserID())
          .then((r) => {
            if (r.status !== 200) this.$fun.alert("Error guardando orden", "error");
          });
      }
    },

    // moveStop - Método para mover un paradero arriba/abajo en la lista
    moveStop(stop, direction) {
      // Ordenar array por orden actual
      const orderedStops = [...this.routeStops].sort(
        (a, b) => (a.BrsStopOrder || 0) - (b.BrsStopOrder || 0)
      );

      // Encontrar el índice del paradero actual
      const currentIndex = orderedStops.findIndex((s) => s.BrsID === stop.BrsID);
      if (currentIndex === -1) return;

      // Calcular nuevo índice (arriba o abajo)
      const newIndex = currentIndex + direction;

      // Verificar que el nuevo índice sea válido
      if (newIndex < 0 || newIndex >= orderedStops.length) return;

      // Intercambiar órdenes
      const temp = orderedStops[currentIndex].BrsStopOrder;
      orderedStops[currentIndex].BrsStopOrder = orderedStops[newIndex].BrsStopOrder;
      orderedStops[newIndex].BrsStopOrder = temp;

      // Actualizar el array original
      this.routeStops = [...orderedStops];

      // Guardar cambios
      this.reindexRouteStops();
    },

    // Métodos complementarios necesarios
    updateStopOrder(stop) {
      // Validar que sea un número positivo
      if (!stop.BrsStopOrder || stop.BrsStopOrder <= 0) {
        this.$fun.alert("El orden debe ser un número positivo", "warning");
        stop.BrsStopOrder = 1;
      }

      // Reindexar todos los paraderos
      this.reindexRouteStops();
    },

    updateStopTime(stop) {
      if (!this.selectedRoute?.RotID) return;

      // Validar formato de hora
      const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;
      if (stop.BrsEstimatedTime && !timeRegex.test(stop.BrsEstimatedTime)) {
        this.$fun.alert("Formato de hora inválido. Use HH:MM", "warning");
        return;
      }

      //   this.$fun.loading(true, "Actualizando tiempo...");
      _smonitoringBusService
        .updateRouteStopTime(
          this.selectedRoute.RotID,
          stop.StpID,
          stop.BrsID,
          stop.BrsEstimatedTime,
          this.$fun.getUserID()
        )
        .then((r) => {
          if (r.status !== 200) {
            this.$fun.alert("Error al actualizar tiempo", "error");
          }
        })
        .catch((err) => {
          console.error("Error actualizando tiempo:", err);
          this.$fun.alert("Error de conexión al actualizar tiempo", "error");
        })
        .finally(() => {
          //   this.$fun.loading(false);
        });
    },
  },
};
</script>

<style scoped>
/* Contenedor del mapa */
.map-container {
  width: 100%;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

/* Estilos para el mapa de Leaflet */
.map-container .leaflet-container {
  /* Asegurar que el mapa tenga el tamaño correcto */
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* Asegurar que el mapa tenga el tamaño correcto */
.leaflet-container {
  width: 100% !important;
  height: 100% !important;
  background: transparent;
  border: none;
}

/* Estilos para el marcador personalizado */
.custom-bus-stop-marker {
  /* Animaciones para el marcador */
  animation: marker-bounce 1s ease-in-out;
}

.custom-bus-stop-marker div {
  background-color: #4caf50;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

/* Estilos para el diálogo */
.v-dialog {
  padding: 16px !important;
  margin: 8px;
}

.v-dialog > .v-card > .v-card__text {
  background: transparent;
  padding: 16px !important;
  border: none;
}

/* Responsivo */
.v-card {
  @media (max-width: 600px) {
    .v-dialog {
      margin: 8px;
    }
    .v-dialog .v-card {
      margin: 0;
    }
  }
}

/* Estilos para el mapa de ruta */
.route-map-container {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

/* Animación para línea de ruta */
@keyframes dash {
  to {
    stroke-dashoffset: 20;
  }
}

/* Flecha para ruta */
.leaflet-marker-icon.arrow-marker {
  background: transparent;
  border: none;
}

/* Estilos para drag & drop de paraderos */
.route-stops-list {
  min-height: 50px;
}

.route-stop-item {
  transition: all 0.3s;
  border: 1px solid #e0e0e0;
}

.ghost-route-stop {
  opacity: 0.5;
  background: #c8e6c9;
  border: 1px dashed #4caf50;
}

.drag-handle {
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}
</style>
